<template>
  <div id="ExamsList">

            <v-list class="pb-0 pt-0 white tileCard"  v-bind:class="{ 'three-line' : exam.examStatus === 'scheduled', 'two-line' : exam.examStatus === 'completed'}">


                <v-list-item  class="grey lighten-5 mt-3" @click="moreInfo(exam)">

                    <v-list-item-content >
                      <v-list-item-title class=" light-blue--text text--darken-3 subheading font-weight-medium" >{{exam.exam_type}}</v-list-item-title>
                      <v-list-item-subtitle >Status: <span v-bind:class="{ 'amber--text text--darken-3' : exam.examStatus === 'Scheduled', 'green--text' : exam.examStatus === 'Completed'}">{{exam.examStatus | capitalizeString}}</span>

                      </v-list-item-subtitle >
                       <v-list-item-subtitle  v-if="exam.examStatus === 'scheduled'" >Scheduled Date: {{exam.date | removeTimeFromDate | moment(" MM/DD/YYYY")}}
                        <!-- <span v-if="college.degree === 'In Progress'" class="caption grey--text">In progress</span>
                        <span v-if="college.degree === 'Completed'" class="caption green--text">{{college.college_degree_awarded}} completed</span> -->
                      </v-list-item-subtitle >


                      <!-- <v-list-tile-sub-title>Total Semesters: {{college.semesters.length}}</v-list-tile-sub-title> -->


                    </v-list-item-content >


                    <v-list-item-action class="mb-3">

                    <v-btn class="mt-2" icon rounded :ripple="false" >
                      <v-icon color="grey">mdi-chevron-right</v-icon>
                      </v-btn>

                    </v-list-item-action>


                </v-list-item>



            </v-list>



  </div>

</template>

<script>
  export default {
    props: ['exam'],
     data() {
      return {
        modal: false,
        alert: false,
        InfoPaShadowingDialog: false,
      }
    },
    methods: {
      moreInfo (exam) {
        this.$router.push('/dashboard/exams/examinfo/' + exam.id)
      }
    },
    computed : {
      user () {
        return this.$store.getters.user
      },
    },
      filters: {
      capitalizeString(string)

        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    },
  }
</script>

<style scoped>
.tileCard {
  border-radius: 10px;
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Exams/ExamsList.vue